module.exports = __webpack_public_path__ + "media/humpback-whale.93041613.mp3";